
export default {
  // welcomeTxt: `欢迎欢迎,我是%template%客服！很高兴为您服务!
  // <br>请输入关键词搜索哦～
  // <br><span style="color: #0087FF">人工客服值班时间：</span>
  // <br>在线支持时间：<span style="color: red">09:00 - 21:00；</span>
  // <br>400客服电话时间：<span style="color: red">9:00 - 12:00, 13:30 - 21:00。</span>`,
  welcomeTxt: `欢迎欢迎,我是%template%客服！很高兴为您服务!
  <br>请输入关键词搜索哦～
  <br><span style="color: #0087FF">人工客服值班时间：</span>
  <br>在线支持时间：<span style="color: red">09:00 - 21:00。</span>`,
  questionsLead: '以下是常见问题列表',
  noWantContent: '没有找到您需要的内容？',
  transferService: '转人工客服（Transfer to customer service）',
  helpful: '有帮助',
  useless: '没帮助',
  guessTips: '我猜您想问的是以下问题，请点击查询',
  noNeedContent: '没有找到您需要的内容？',
  send: '发送',
  searchNoEmptyTips: '搜索内容不能为空',
  inputPlaceholder: '请输入问题',
  linkService: '正在为您连接客服...',
  copy: '复制',
  withdraw: '撤回',
  history: '历史记录',
  customerWithdrew: '客服撤回了一条消息',
  youWithdrew: '你撤回了一条消息',
  photoAlbum: '相册',
  video: '视频',
  file: '文件',
  serviceRating: '服务评价',
  rantingLead: '为了更好的帮助您，请对我们的服务进行评价<br>请问 <span>客服%template%</span> 是否解决了您的问题？',
  satisfactory: '非常满意',
  unsatisfactory: '不满意',
  satisfactoryOptionsTips: '夸夸客服（可多选）',
  unSatisfactoryOptionsTips: '有哪些不足（可多选）',
  goodAttitude: '服务态度好',
  respondPromptly: '回复及时',
  solveTheProblem: '回答专业程度高',
  badAttitude: '态度不好',
  noRespondInTime: '回复不及时',
  notSolvingTheProblem: '回答不专业',
  submit: '提交',
  noSubmit: '暂不提交',
  problemFeedback: '离线问题反馈',
  account: '账号',
  accountPlaceholder: '请输入用户ID',
  phone: '手机号',
  phonePlaceholder: '请输入您的手机号',
  errorPhoneTips: '请输入正确的手机号',
  problemDescription: '问题描述',
  problemDescriptionPlaceholder: '如果是课堂问题，请提供详细上课时间，具体问题描述。',
  descriptionRequiredTips: '请输入问题描述',
  cancel: '取消',
  sendPictures: '发送图片',
  submittedSuccessfully: '提交成功',
  copySuccessfully: '复制成功',
  tips: '提示',
  leaveAMessage: '留言',
  noWorkTimeTips: '当前暂无客服在线\n请使用智能机器人搜索提问您想问的问题',
  labelSelectTips: '请选择至少一个评价标签！',
  noFreeService: '暂无空闲客服',
  goBack: '返回',
  useRobotTips: '请使用智能机器人搜索提问您想问的问题',
  multipleAccountTips: '您的账号在其他地方被登录',
  loginSessionExpired: '登录失效',
  fileTypeTips: '请选择 .doc, .docx, .pdf, ppt格式的文件发送',
  fileSizeTips: '文件大小不能超过50M',
  cannotSendEmpty: '不允许发送空消息',
  pleaseSelectVideo: '请选择视频发送',
  videoSizeTips: '视频大小不能超过50M',
  Sending: '发送中',
  viewVideoPleaseClick: '查看视频请点击',
  sendingfailedTryAgainTips: '发送失败,请重试',
  selectPictureToSend: '请选择图片发送',
  pictureSizeTips: '图片大小不能超过10M',
  yes: '允许',
  allowAccessFiles: '是否允许访问您的文件',
  failInSend: '发送失败',
  imageSendingFailed: '图片发送失败',
  fileSendingFailed: '文件发送失败',
  VideoSendingFailed: '视频发送失败',
  imageNotCompliantTips: '发送的图片不合规',
  date: '日期',
  chatDateRange: '聊天日期范围',
  noRecords: '暂无记录',
  alreadyEvaluatedTips: '您已评价过',
  linkFinished: '客服连接已结束',
  inDepthThinking: '深度思考中...',
  deeplyPondered: '已深度思考',
  askErrorTips: '出错了，您可以重新提问',
  noInServiceTimeTips: '当前不在客服服务时间，您可以',
  noOnlineServiceTips: '当前没有客服在线，请使用智能机器人搜索提问您想问的问题。',
  aiWaitTips: 'AI回答中，请稍等或取消上一个问题~',
  noFindContentTips: '没有找到相关内容，您可以重新提问。',
  registeredPhone: '注册手机号',
  linkServiceHelpTips: '您可以输入“人工”、“在线客服”联系客服获取帮助，或输入“工单”、“提工单”提交您当前的疑问。',
  timeout_tips: '您长时间未回复，已自动退出人工对话。',
  recallWaitTips: '消息还未发送完成，请稍等...',
  consultation_has_ended: '当前对话已结束'
}



// WEBPACK FOOTER //
// ./src/theme/cnLang.js